import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { movieTypesHash } from '@culture/utils/helpers/movies';

import SimpleGrid from 'components/SimpleGrid';

import EntitiesPropTypes from 'utils/propTypes/entities';

import Entity from './Entity';

const Group = ({ items }) => {
	const isVerticalOrientation = _([
		movieTypesHash.movie,
		movieTypesHash.performance
	]).contains(items[0]?.movie?.type);

	return (
		<SimpleGrid
			theme={isVerticalOrientation ? 'verticalCards' : 'horizontalCards'}
		>
			{items.map(({ type, [type]: entity }) => (
				<Entity key={entity._id} type={type} entity={entity} size="elastic" />
			))}
		</SimpleGrid>
	);
};

Group.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			movie: EntitiesPropTypes.broadcastItem
		})
	)
};

export default Group;
